// extracted by mini-css-extract-plugin
export default {"wrapper":"DefinableWord_wrapper__kT7RQ","greenArrow":"DefinableWord_greenArrow__s37Ky"};